module.exports = __webpack_public_path__ + "img/icon_indi_panel.39b03df1.svg";